import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'is_the_fac_failing_to_comply_w_legal_reqs_for_any_of_the_follow'

export const dataPointDefinition = {
  retracedId: 'is_the_fac_failing_to_comply_w_legal_reqs_for_any_of_the_follow',
  name: 'Is the facility failing to comply with legal requirements for any of the following related to first aid?',
  description:
    'Consult applicable legal requirements before answering this question. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'FIRST_AID_KITS_ARE_NOT_SUFFICIENT_IN_NUMBER',
      text: 'First-aid kits are not sufficient in number',
      externalIds: [
        {
          id: 'hs-fir-24',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FIRST_AID_KITS_ARE_NOT_SUFFICIENTLY_MAINTAINED_NOT_FULLY_STOCKE',
      text: 'First-aid kits are not sufficiently maintained (not fully stocked and contain expired items)',
      externalIds: [
        {
          id: 'hs-fir-25',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FIRST_AID_KITS_ARE_NOT_CLEARLY_MARKED_AND_NOT_READILY_ACCESSIBL',
      text: 'First aid kits are not clearly marked and not readily accessible',
      externalIds: [
        {
          id: 'hs-fir-26',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_DOES_NOT_TRAIN_A_SUFFICIENT_NUMBER_OF_WORKERS_IN_FIRST',
      text: 'Facility does not train a sufficient number of workers in first aid',
      externalIds: [
        {
          id: 'hs-fir-27',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FIRST_AID_TRAINING_RECORDS_ARE_NOT_RETAINED',
      text: 'First aid training records are not retained',
      externalIds: [
        {
          id: 'hs-fir-28',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-fir-29',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'FIRST_AID_KITS_ARE_NOT_SUFFICIENT_IN_NUMBER',
                'FIRST_AID_KITS_ARE_NOT_SUFFICIENTLY_MAINTAINED_NOT_FULLY_STOCKE',
                'FIRST_AID_KITS_ARE_NOT_CLEARLY_MARKED_AND_NOT_READILY_ACCESSIBL',
                'FACILITY_DOES_NOT_TRAIN_A_SUFFICIENT_NUMBER_OF_WORKERS_IN_FIRST',
                'FIRST_AID_TRAINING_RECORDS_ARE_NOT_RETAINED',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-fir-23',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 16700,
  sectionId: '2.2.9.4',
  impactArea: 'Emergency Preparedness',
  impactAreaId: 'EMERGENCY_PREPAREDNESS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
